import { MessageBar, MessageBarBody, MessageBarTitle } from "@fluentui/react-components";
import { Col, Row } from "react-grid-system";
import { useTranslation } from "react-i18next";

const Error = () => {
    const { t } = useTranslation();
    
    return (
        <Row>
            <Col>
                <MessageBar intent='error'>
                    <MessageBarBody>
                        <MessageBarTitle>{t("general.error")}</MessageBarTitle>
                        {t("passwords.errors.loadPasswords")}
                    </MessageBarBody>
                </MessageBar>
            </Col>
        </Row>
    );
};

export default Error;